// extracted by mini-css-extract-plugin
export default {"container":"OpinionHistory_container__tLSvH","wrapper":"OpinionHistory_wrapper__-tl03","divUp":"OpinionHistory_divUp__wU+rW","pageTitle":"OpinionHistory_pageTitle__HiQWJ"};